import { LOGIN_REQUEST } from '@Constants/authorizationConstants';
import { LoginButton as SharedLoginButton } from '@synqo/cloud-client-shared';

export function LoginButton(props: { minimal?: boolean }) {
    return <SharedLoginButton {...props} loginRequest={LOGIN_REQUEST} />;
}
